import styled from "styled-components";

import { Button } from "ds/Button";

export const DeleteAlertButton = styled(Button)`
  margin-right: auto;
`;

export const LoadingDeleteWrapper = styled.div`
  margin-right: auto;
`;
